import { DotsRow, Dot } from './styled'
import { ProgressDotsProps } from './types'

/**
 * Tiny step indicator for the onboarding wizard. Current step renders
 * elongated; upcoming steps render dot-sized; completed steps stay
 * filled.
 *
 * @param {ProgressDotsProps} props
 * @returns {JSX.Element}
 */
const ProgressDots = ({
  totalSteps,
  currentStepIndex,
}: ProgressDotsProps): JSX.Element => {
  const indices = Array.from({ length: totalSteps }, (_unused, index) => index)

  return (
    <DotsRow>
      {indices.map(index => {
        const stateValue =
          index < currentStepIndex
            ? 'complete'
            : index === currentStepIndex
              ? 'current'
              : 'upcoming'

        return <Dot key={index} state={stateValue} />
      })}
    </DotsRow>
  )
}

export default ProgressDots
